export default __webpack_public_path__ + "static/media/icone.0e16690d.png";